<template>
  <footer class="footer">
    <a class="footer_wg-logo">Lesta.ru</a>
    <div class="footer_links">
      <span class="footer_item">
        <a class="footer_link" :href="supportUrl" target="_blank" @click="onSupportClick">{{ $t('Сообщить о проблеме') }}<LinkIcon /></a>
      </span>
    </div>
    <div class="footer_region" v-if="currentCountry">
      <span class="footer_label">{{ $t('Банковская карта для:')}}</span>
      <RegionSelectButton
        :active="showRegionOverlay"
        @click="showRegionOverlay = !showRegionOverlay"
      />
    </div>
    <div class="footer_divider" />
    <LicenseView :year="currentYear" />
    <ul class="footer_onetrust">
      <li><a class="footer_link" target="_blank" :href="privacyPolicyUrl">{{ $t('Политика конфиденциальности') }}</a></li>
    </ul>
    <p class="footer_copyright">
      © Леста Игры, {{ startDate }}–{{ currentYear }}. Игры «Мир танков», «Мир кораблей», Tanks Blitz основаны на интеллектуальной
      собственности третьих лиц. Все права на объекты прав третьих лиц принадлежат их законным правообладателям.
    </p>
    <RegionSelectOverlay
      v-if="showRegionOverlay"
      @close="showRegionOverlay = false"
    />
  </footer>
</template>

<script>
import { Vue, Component, Watch } from 'vue-property-decorator'
import { Mutation, State } from 'vuex-class'
import { SUPPORT_PORTAL_LINK_URL, PRIVACY_POLICY_LINK_URL } from '@/constants'

import RegionSelectOverlay from '../RegionSelect/RegionSelectOverlay.vue'
import RegionSelectButton from '../RegionSelect/RegionSelectButton.vue'
import LicenseView from './License/License'
import LinkIcon from '@/common/components/Decoration/LinkIcon'

@Component({
  components: { RegionSelectOverlay, RegionSelectButton, LicenseView, LinkIcon }
})
class PageFooter extends Vue {
  @State('country') currentCountry
  @Mutation('ui/SET_SCROLL_LOCK') setScrollLock

  showRegionOverlay = false
  supportUrl = SUPPORT_PORTAL_LINK_URL
  privacyPolicyUrl = PRIVACY_POLICY_LINK_URL

  startDate = 2022

  get currentYear () {
    return new Date().getFullYear()
  }

  @Watch('showRegionOverlay')
  onShowRegionOverlayChanged (isOpen) {
    this.setScrollLock(isOpen)
  }

  onSupportClick () {
    this.$analytics.trackSupportButtonClick({ screenId: this.$route.name, linkUrl: this.supportUrl })
  }
}

export default PageFooter
</script>

<style lang="scss">
$footer_border: 1px solid rgba(255, 255, 255, .1);

.footer {
  background: $background-color;
  border-top: $footer_border;
  font-size: 12px;
  position: relative;
  padding: 0 0 30px;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto auto auto auto auto auto;
  grid-template-areas:
    "footer_links"
    "footer_country_switcher"
    "footer_divider"
    "footer_wglogo"
    "footer_wg_copy"
    "footer_license"
    "footer_onetrust";
  /* autoprefixer: ignore next */
  justify-items: center;

  @include media_tablet {
    padding: 30px 30px 30px;
    font-size: 14px;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
    grid-template-areas:
      "footer_links footer_country_switcher"
      "footer_divider footer_divider"
      "footer_wglogo footer_wglogo"
      "footer_wg_copy footer_wg_copy"
      "footer_license footer_onetrust";
    /* autoprefixer: ignore next */
    justify-items: normal;
  }
  @include media_desktop {
    font-size: 16px;
    padding: 47px 48px 45px;
    grid-template-columns: 23% 1fr 2fr;
    grid-template-rows: auto auto auto;
    grid-template-areas:
      "footer_wglogo footer_links footer_country_switcher"
      "footer_divider footer_divider footer_divider"
      "footer_license footer_onetrust footer_wg_copy";
  }

  &_item {
    align-self: normal;
    border-bottom: $footer_border;
    padding: 14px 0;
    text-align: center;
    @include media_tablet {
      align-self: auto;
      border: none;
      margin-right: 20px;
      padding: 0;
    }
    @include media_desktop {
      margin-right: 40px;
    }
  }
  &_links {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    grid-area: footer_links;
  }
  &_link {
    color: $font-color;
    font-size: 14px;
    text-decoration: none;
    transition: color $duration;

    &:hover {
      color: #fff;
    }
    @include media_desktop {
      font-size: 16px;
    }
  }
  &_region {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    grid-area: footer_country_switcher;
    flex-direction: column;
    @include media_tablet {
      flex-direction: row;
    }
  }
  &_label {
    font-size: 14px;
    margin: 13px 0 10px;
    @include media_tablet {
      margin: 0 10px 0 0;
    }
    @include media_desktop {
      font-size: 16px;
    }
  }
  &_info {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 30px;
    @include media_tablet {
      flex-direction: row;
      justify-content: space-between;
      align-items: normal;
      padding: 0;
    }
    @include media_desktop {
      padding: 6px 40px 0 0;
    }
  }
  &_wg-logo {
    @include invisible-text;
    background: url("./logo.svg") no-repeat;
    background-size: contain;
    display: inline-block;
    width: 120px;
    height: 26px;
    margin: 0 0 19px;
    grid-area: footer_wglogo;
    @include media_tablet {
      display: block;
      width: 148px;
      height: 36px;
      margin: 0;
    }
    @include media_desktop {
      margin-right: 40px;
    }
  }
  &_text {
    text-align: center;
    @include media_tablet {
      text-align: right;
    }
    @include media_desktop {
      text-align: left;
    }
  }
  &_license, &_onetrust {
    font-weight: 400;
    margin-bottom: 13px;
    text-align: center;
    grid-area: footer_license;
    padding: 20px;
    margin-top: 20px;
    border-top: $footer_border;
    box-sizing: border-box;
    width: 100%;

    @include media_tablet {
      width: auto;
      text-align: left;
      margin-bottom: 5px;
      margin-top: 30px;
      padding-top: 40px;
      position: relative;
      border-top: none;
    }
    @include media_desktop {
      margin-top: 0;
      padding: 0;
    }
    &:before {
      @include media_tablet {
        content: '';
        position: absolute;
        left: -30px;
        top: 0;
        width: calc(100% + 30px * 2);
        border-top: $footer_border;
      }
      @include media_desktop {
        display: none;
      }
    }
    p:last-child {
      margin-bottom: 0;
    }
  }
  &_onetrust {
    grid-area: footer_onetrust;
    li {
      margin-top: 17px;
      margin-bottom: 35px;
    }
    li:first-child {
      margin: 0;
    }
    a {
      cursor: pointer;
    }
  }
  &_text-link {
    color: $font-color;
    text-decoration: none;
  }
  &_copyright {
    grid-area: footer_wg_copy;
    padding: 0 20px;
    @include media_tablet {
      padding: 20px 0;
      display: flex;
      justify-content: flex-end;
    }
    @include media_desktop {
      padding: 0;
      justify-content: flex-start;
    }
  }
  &_divider {
    grid-area: footer_divider;
    position: relative;
    padding: 20px 0;
    width: 100%;
    @include media_tablet {
      padding: 35px 0 40px;
    }
    &:after {
      content: '';
      display: block;
      position: absolute;
      border-top: $footer_border;
      left: 0;
      width: 100%;
      @include media_tablet {
        left: -30px;
        width: calc(100% + 30px * 2);
      }
      @include media_desktop {
        width: calc(100% + 48px * 2);
        left: -48px;
      }
    }
  }
}
</style>
